import CodeError from './error'

export type InitMethod =
  | 'GET'
  | 'POST'
  | 'PUT'
  | 'DELETE'
  | 'PATCH'
  | 'OPTIONS'
  | 'HEAD'

export interface Init<T = any> {
  query?: Record<string, string>
  path: string
  method: InitMethod
  headers?: HeadersInit
  body?: T
  mapper?: (data: any) => T
  signal?: AbortSignal
}

export default async function client<T = any>(
  init: Init,
): Promise<[null, CodeError] | [T, null]> {
  let query = new URLSearchParams(init.query ?? {}).toString()
  if (query) query = `?${query}`
  let path = `${init.path}${query}`

  // A multipart body carries its own content type, and the boundary in it is
  // known only to whoever serialised the form, so neither the header nor the
  // body may be touched here.
  const form = init.body instanceof FormData

  const res = await fetch(path, {
    // dispatcher,
    method: init.method,
    cache: 'no-store',
    headers: {
      ...(init.headers ?? {}),
      ...(form ? {} : { 'Content-Type': 'application/json' }),
    },
    body: form ? init.body : init.body ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
  })

  if (res.status >= 400) {
    let resp = await CodeError.fromResponse(res)
    return [null, resp]
  }

  const json = await res.json()

  if (init.mapper) {
    return [init.mapper(json), null]
  }

  return [json, null]
}
